<template>
    <div>
        <ValidationObserver slim ref="form">
            <form @submit.prevent="onSubmit">
                <p>
                    <label for="login">Identifiant</label>
                    <ValidationProvider slim name="login" rules="required|email" v-slot="{ classes, errors }">
                        <input type="text" name="login" id="login" :class="classes" v-model="item.name" />
                        <span class="error-txt">{{ errors[0] }}</span>
                    </ValidationProvider>
                </p>

                <input type="submit" value="Valider"/>

            </form>
        </ValidationObserver>
        <p>&nbsp;</p>
        <p v-if="error">{{ error }}</p>
        <p v-if="success">{{ success }}</p>
    </div>
</template>
<script>

export default {
    mounted() {

    },
    data() {
        return {
            loader: false,
            error: null,
            success: null,
            item: {}
        }
    },
    methods: {
        onSubmit() {
            if (this.loader)
                return;

            this.loader = true;
            this.$refs.form.validate().then(success => {
                if (!success) {
                    this.loader = false;
                    return;
                }

                this.requestResetLink();
            });
        },
        requestResetLink() {
            this.error = null;
            axios({
                method: 'post',
                url: window.Routes.forgot_password,
                data: this.item
            }).then((response) => {
                this.success = response.data.success;
            }).catch((error) => {
                this.error = error.response.data.error;
            }).finally(() => {
                this.loader = false;
            });
        }
    }
}
</script>
